<template>
  <div>
    <div class="book-time-single-date-xs booking-mobile-top-controls">
      <div class="provider-and-calendar-nav-mobile-buttons">
        <ToggleSelectProviderMobile />
      </div>
      <div class="provider-and-calendar-nav-mobile-buttons">
        <!-- City dropdown should be visible in the timeslots view (mobile), to the right of "Behandlare" -->
        <div class="nk-city-dropdown-mobile" v-if="cities && cities.loaded && cities.available && cities.available.length > 1">
          <div class="custom-dropdown" @click="toggleOpen">
            <div
              class="custom-dropdown-selected nk-button"
              :class="{ 'nk-button-light-nude': !cities.selected }"
            >
              <span class="selected-text">
                {{
                  cities.selected && cities.selected.name
                    ? `${cities.selected.name}`
                    : 'Välj stad'
                }}
              </span>
              <span class="dropdown-chevron" :class="{ rotated: open }">
                <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
                  <path
                    d="M3 4.5L6 7.5L9 4.5"
                    stroke="currentColor"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </span>
            </div>
            <div class="custom-dropdown-options" v-if="open">
              <div
                v-for="city in cities.available"
                :key="city.id"
                class="dropdown-option"
                @click.stop="selectCity(city)"
                :class="{ active: cities.selected && cities.selected.id === city.id }"
              >
                {{ city.name }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Location selection still lives below (for cities with multiple clinics/locations) -->
    <ToggleSelectLocationMobile />
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";

import ToggleSelectProviderMobile from "./ToggleSelectProviderMobile.vue";
import ToggleSelectLocationMobile from "./ToggleSelectLocationMobile.vue";
export default {
  components: { ToggleSelectProviderMobile, ToggleSelectLocationMobile },
  data() {
    return { open: false };
  },
  computed: {
    ...mapState(["ui", "providers", "locations", "cities"]),
    ...mapGetters([]),
  },
  mounted() {
    document.addEventListener("click", this._onDocClick);
  },
  beforeDestroy() {
    document.removeEventListener("click", this._onDocClick);
  },
  methods: {
    ...mapActions(["calendarViewType", "toggleSelectingProvider", "setSelectedCity"]),
    _onDocClick(e) {
      const dropdown = this.$el && this.$el.querySelector(".nk-city-dropdown-mobile .custom-dropdown");
      if (dropdown && !dropdown.contains(e.target)) {
        this.open = false;
      }
    },
    toggleOpen() {
      this.open = !this.open;
    },
    selectCity(city) {
      this.open = false;
      this.setSelectedCity(city);
    },
  },
};
</script>
